import React from 'react';
import { mockVehicles } from '../data/mockVehicles';

const Vehicles = () => {
  return (
    <div className="bg-black pt-32 pb-20">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold mb-12">Nos <span className="text-orange-500">Véhicules</span></h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockVehicles.map((car) => (
            <div key={car.id} className="bg-gray-900 rounded-xl overflow-hidden group border border-gray-800 hover:border-orange-500 transition">
              <div className="h-64 overflow-hidden">
                <img src={car.image} alt={car.model} className="w-full h-full object-cover group-hover:scale-110 transition duration-500" />
              </div>
              <div className="p-6">
                <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">{car.condition}</span>
                <h3 className="text-2xl font-bold mt-2 mb-4">{car.brand} {car.model}</h3>
                <div className="flex justify-between text-gray-400 text-sm mb-6">
                  <span>{car.year}</span>
                  <span>{car.fuel}</span>
                  <span>{car.transmission}</span>
                </div>
                <a href="https://wa.me/243828706717" className="block text-center bg-white text-black py-3 rounded-md font-bold hover:bg-orange-500 hover:text-white transition">Commander</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Vehicles;
